import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { useFormField } from '../../../utils';
export var useHandleSelect = function useHandleSelect(props) {
  var _useFormField = useFormField({
    name: props.name
  }),
      value = _useFormField.meta.value,
      _useFormField$helpers = _useFormField.helpers,
      setValue = _useFormField$helpers.setValue,
      setTouched = _useFormField$helpers.setTouched;

  var _useFormikContext = useFormikContext(),
      handleSubmit = _useFormikContext.handleSubmit,
      isSubmitting = _useFormikContext.isSubmitting;

  var handleSelect = useCallback(function (value) {
    if (isSubmitting) {
      return;
    }

    setTouched(true);
    setValue(value);
    /**
     * Не трогай таймаут - оно здесь надо.
     * Если значение поля еще не было установленно, без таймаута внутри
     * сабмит и не вызывается переход на следующий шаг (таймаут ставит макротаску в очередь с отсрочкой).
     * Видимо связанно с тем, что формик не успевает отследить/среагировать на изменения в своем стейте.
     * Ранее решалось хуком useCallFnAfterFormikChanged, но это вызывало баг при изменении значения поля
     * внутри формика (например при отмены перехода на следующий шаг со сбросом формы к предыдущему значению)
     * - повторный выбор "отмененного" варианта ответа "залипал" и форма не сабмитились.
     */

    setTimeout(function () {
      handleSubmit();
    }, 0);
  }, [handleSubmit, isSubmitting, setTouched, setValue]);
  return {
    value: value,
    handleSelect: handleSelect
  };
};